export default __webpack_public_path__ + "static/media/11.24.a1b9bd8e.jpg";